import React from "react";
import { connect } from "react-redux";
import { Formik } from "formik";

import { downloadReportByKey } from "actions";
import { Form } from "react-bootstrap";
import { FormFilter, DateInput, Select } from "components/forms";
import NumericInput from "../../../components/forms/NumericInput";
import { DownloadButtonReport } from "./DownloadButtonReport";
import { managementChoicesSelector } from "../../../reducers";

const LeadsReport = props => {
  let initialValues = {};
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting }) => {
        props.downloadReportByKey("leads", values);
      }}
    >
      {({ handleSubmit, setFieldValue, setSubmitting }) => {
        return (
          <FormFilter title={"Leads Report"} onSubmit={handleSubmit}>
            <Form.Row>
              <DateInput label="Lead Create Start" name="date_from" />
              <DateInput label="Lead Create End" name="date_to" />
              <Select
                label="Sales Rep"
                name="sales_representative"
                placeholder="Select Sales Rep"
                options={props.salesRepChoices?.getChoices({ sortByLabel: true }) || []}
              />
              <NumericInput label="Score Min" name="score_min" />
              <NumericInput label="Score Max" name="score_max" />
              <DownloadButtonReport />
            </Form.Row>
          </FormFilter>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const choices = managementChoicesSelector(state);

  return {
    salesRepChoices: choices.case_sales_representatives,
  };
};

export default connect(mapStateToProps, {
  downloadReportByKey,
})(LeadsReport);
